export default __webpack_public_path__ + "static/media/mobileMezzoSlide.001ef7e9.png";